<template>
  <div>
    <button type="button" class="w-full btn btn--success" @click="toggleModal" v-tooltip="'Add Supplier'">
      Add Supplier    
    </button>    
    <!-- Import Modal Dialog -->
    <modal :show="showModal" @close="showModal = false" addClass="modal-md" modalOrientation="pt-16 md:pt-5 md:flex md:items-center md:justify-center">
      <template v-slot:header><h3>{{ modalTitle }}</h3></template>
      <template v-slot:body>
        <ValidationObserver v-slot="{ handleSubmit }">
          <form id="supplierForm" @submit.prevent="handleSubmit(create)">
            <div class="md:flex gap-6">
              <div class="w-full mb-4">
                <ValidationProvider name="Supplier Name" rules="required" v-slot="{ errors }">
                  <label for="supplier_name" class="label-control">Supplier Name <span class="text-red-600">*</span></label>
                  <input id="supplier_name" ref="supplier_name" type="text" v-model="supplierName" maxlength="255" class="form-control" autofocus>
                  <span class="text-sm text-red-600 w-full">{{ errors[0] }}</span>           
                </ValidationProvider>
                <div v-if="error.supplier_name" class="text-sm text-red-600"><span>{{ error.supplier_name[0] }}</span></div>              
              </div>
            </div>          
            <div class="md:flex gap-6">
              <div class="w-full mb-4">
                <ValidationProvider name="Address" rules="" v-slot="{ errors }">
                  <label for="address" class="label-control">Address</label>
                  <textarea id="address" v-model="address" class="form-control" rows="5"></textarea>
                  <span class="text-sm text-red-600 w-full">{{ errors[0] }}</span>           
                </ValidationProvider>
                <div v-if="error.address" class="text-sm text-red-600"><span>{{ error.address[0] }}</span></div>                   
              </div>
            </div>
            <div class="md:flex gap-6">
              <div class="md:w-1/2 mb-4">
                <ValidationProvider name="Postal Code" rules="numeric" v-slot="{ errors }">
                  <label for="postal_code" class="label-control">Postal Code</label>
                  <input id="postal_code" type="text" v-model="postalCode" class="form-control">
                  <span class="text-sm text-red-600 w-full">{{ errors[0] }}</span>           
                </ValidationProvider>
                <div v-if="error.postal_code" class="text-sm text-red-600"><span>{{ error.postalCode[0] }}</span></div>
              </div>
              <div class="md:w-1/2 mb-4">
                <ValidationProvider name="City" rules="alpha_spaces" v-slot="{ errors }">
                  <label for="city" class="label-control">City</label>
                  <input id="city" type="text" v-model="city" class="form-control">
                  <span class="text-sm text-red-600 w-full">{{ errors[0] }}</span>           
                </ValidationProvider>
                <div v-if="error.city" class="text-sm text-red-600"><span>{{ error.city[0] }}</span></div>
              </div>
            </div>          
            <div class="md:flex gap-6">
              <div class="md:w-1/2 mb-4">
                <ValidationProvider name="Country" rules="alpha_spaces" v-slot="{ errors }">
                  <label for="country" class="label-control">Country</label>
                  <input id="country" type="text" v-model="country" class="form-control">
                  <span class="text-sm text-red-600 w-full">{{ errors[0] }}</span>           
                </ValidationProvider>
                <div v-if="error.country" class="text-sm text-red-600"><span>{{ error.country[0] }}</span></div> 
              </div>
              <div class="md:w-1/2 mb-4"></div>
            </div>
          </form> 
        </ValidationObserver>        
      </template>
      <template v-slot:footer>
        <button :disabled="isLoading" type="submit" form="supplierForm" class="btn btn--primary">
          Save
        </button>      
      </template> 
    </modal>
  </div>
</template>

<script>
import supplierServices from '@/services/supplier/supplierServices'
import Modal from '../../widgets/Modal'

export default {
  name: 'SupplierModal',
  components: {
    Modal,
  },
  data() {
    return {
      supplierName: '',
      address: '',
      postalCode: '',
      city: '',
      country: '',
      error: [],
      isLoading: false, 
      modalTitle: '',     
      showModal: false,
      toastedOptions: {
        position: "top-right", 
        duration : 5000,
        action: {
          text: 'x',
          onClick: (e, toastObject) => {
            toastObject.goAway(0)
          }
        }  
      }         
    }
  },
  methods: {
    toggleModal() {
      this.showModal = true
      this.modalTitle = 'Suppliers'
    },
    async create(){
      try {
        this.isLoading = true       
        const payload = {
          supplier_name: this.supplierName,
          address: this.address,
          postal_code: this.postalCode,
          city: this.city,
          country: this.country
        }
        const response = await supplierServices.create(payload)
        if (response.data.status === 'success') {
          /* SET LOADING STATE IS FALSE */
          this.isLoading = false
                    
          /* CLEAR INPUT FORM */
          this.clearForm()

          /* EMPTY ERRORS VARIABLE */
          this.error = []
          
          /* SUCCESS MESSAGES */
          this.$toasted.success(response.data.message, this.toastedOptions)

          this.fetchSupplier()

          this.showModal = false
        } else {
          /* SET LOADING STATE IS FALSE */
          this.isLoading = false

          /* EMPTY ERRORS VARIABLE */
          this.error = []

          /* STORE RESPONSE MESSAGE TO A VARIABLE */
          let responseReturn = response.data.message

          /* IF RESPONSE HAS OBJECT, STORE RESPONSE TO ERRORS VARIABLE */
          if (responseReturn.supplier_name) {
              this.error = response.data.message

          /* ELSE, THROW ERROR MESSAGES */
          } else {
            this.$toasted.error(response.data.message, this.toastedOptions)
          }          
        }
      } catch (error) {
        /* SET LOADING STATE IS FALSE */
        this.isLoading = false

        /* THROW ERROR MESSAGES */
        this.$toasted.error(error, this.toastedOptions)        
      }
    },
    clearForm(){
      this.supplierName = ''
      this.address = ''
      this.postalCode = ''
      this.city = ''
      this.country = ''
    },    
    fetchSupplier() {
      this.$root.$emit('fetchSupplier')      
    }        
  }
}
</script>